import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  RESET_REGISTER_FLAG,
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESSFUL,
  VERIFY_EMAIL_FAILED,
  VERIFY_EMAIL_REQUEST_NEW_TOKEN,
  VERIFY_EMAIL_REQUEST_NEW_TOKEN_SUCCESSFUL,
  VERIFY_EMAIL_REQUEST_NEW_TOKEN_FAILED,
  CREATE_COMPANY,
  CREATE_COMPANY_SUCCESSFUL,
  CREATE_COMPANY_FAILED,
  VERIFY_USER_INVITATION,
  VERIFY_USER_INVITATION_SUCCESSFUL,
  VERIFY_USER_INVITATION_FAILED,
  ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT,
  ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_SUCCESSFUL,
  ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_FAILED,
  AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET,
  AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_SUCCESSFUL,
  AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_FAILED,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_FAILED,
} from "./actionTypes";

const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false,
  verifyEmailSuccess: [],
  loadingVerifyEmail: false,
  verifyEmailRequestSuccess: [],
  createCompanyLoading: false,
  createCompanySuccess: [],
  verifyUserJoinSuccess: [],
  verifyUserJoinLoading: false,
  acceptInviteCreateNewUserAccountSuccess: [],
  acceptInviteCreateNewUserAccountLoading: false,
  authenticationRequestForEmailPasswordResetSuccess: [],
  resetPasswordSuccess: [],
};

const Account = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER:
      return {
        ...state,
        loading: true,
      };
    case REGISTER_USER_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload,
        success: true,
        error: false,
      };
    case REGISTER_USER_FAILED:
      return {
        ...state,
        loading: false,
        registrationError: action.payload,
        success: false,
        error: true,
      };
    case RESET_REGISTER_FLAG:
      return {
        ...state,
        success: false,
        error: false,
      };
    case VERIFY_EMAIL:
      return {
        ...state,
        loadingVerifyEmail: true,
      };
    case VERIFY_EMAIL_SUCCESSFUL:
      return {
        ...state,
        loadingVerifyEmail: false,
        verifyEmailSuccess: action.payload,
      };
    case VERIFY_EMAIL_FAILED:
      return {
        ...state,
        loadingVerifyEmail: false,
        verifyEmailSuccess: action.payload,
      };
    case VERIFY_EMAIL_REQUEST_NEW_TOKEN:
      return {
        ...state,
        loadingVerifyEmail: true,
      };
    case VERIFY_EMAIL_REQUEST_NEW_TOKEN_SUCCESSFUL:
      return {
        ...state,
        loadingVerifyEmail: false,
        verifyEmailRequestSuccess: action.payload,
      };
    case VERIFY_EMAIL_REQUEST_NEW_TOKEN_FAILED:
      return {
        ...state,
        loadingVerifyEmail: false,
        verifyEmailRequestSuccess: action.payload,
      };
    case CREATE_COMPANY:
      return {
        ...state,
        createCompanyLoading: true,
      };
    case CREATE_COMPANY_SUCCESSFUL:
      return {
        ...state,
        createCompanyLoading: false,
        createCompanySuccess: action.payload,
      };
    case CREATE_COMPANY_FAILED:
      return {
        ...state,
        createCompanyLoading: false,
        createCompanySuccess: action.payload,
      };
    case VERIFY_USER_INVITATION:
      return {
        ...state,
        verifyUserJoinLoading: true,
      };
    case VERIFY_USER_INVITATION_SUCCESSFUL:
      return {
        ...state,
        verifyUserJoinSuccess: action.payload,
        verifyUserJoinLoading: false,
      };
    case VERIFY_USER_INVITATION_FAILED:
      return {
        ...state,
        verifyUserJoinSuccess: action.payload,
        verifyUserJoinLoading: false,
      };
    case ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT:
      return {
        ...state,
        acceptInviteCreateNewUserAccountLoading: true,
      };
    case ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_SUCCESSFUL:
      return {
        ...state,
        acceptInviteCreateNewUserAccountSuccess: action.payload,
        acceptInviteCreateNewUserAccountLoading: false,
      };
    case ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_FAILED:
      return {
        ...state,
        acceptInviteCreateNewUserAccountSuccess: action.payload,
        acceptInviteCreateNewUserAccountLoading: false,
      };
    case AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET:
      return {
        ...state,
        loading: true,
      };
    case AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        authenticationRequestForEmailPasswordResetSuccess: action.payload,
      };
    case AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_FAILED:
      return {
        ...state,
        loading: false,
        authenticationRequestForEmailPasswordResetSuccess: action.payload,
      };
    case RESET_PASSWORD:
      return {
        ...state,
        loading: true,
      };
    case RESET_PASSWORD_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        resetPasswordSuccess: action.payload,
      };
    case RESET_PASSWORD_FAILED:
      return {
        ...state,
        loading: false,
        resetPasswordSuccess: action.payload,
      };

    default:
      return state;
  }
};

export default Account;
